import { getLocalizedValue } from "services/sosInventoryService/salesTransaction/domainLogic";
import { convertNativeToCustom } from "services/utility/customFields";
import { normalizeJobWorkCenter } from "services/utility/jobWorkCenter";
import { cleanTransactionNumber } from "services/utility/misc";
import { TYPES } from "services/utility/schema";

import globalState from "globalState/globalState";

import { LINE_ITEM_FIELDS } from "editConfig";

export function salesTransactionBeforeSave(objectType, record) {
  const newRecord = { ...record };

  newRecord.number = cleanTransactionNumber(record.id, record.number);

  // convert any number or currency fields that are "" to zero
  const fieldsToCheck = [
    "depositAmount",
    "depositPercent",
    "discountAmount",
    "discountPercent",
    "shippingAmount",
    "taxAmount",
    "taxPercent",
  ];
  fieldsToCheck.forEach((field) => {
    if (record[field] === "") {
      newRecord[field] = 0;
    }
  });

  // remove any line items with no inventory item
  let materialLines = record.lines.filter(({ item }) => item?.id);

  // although taxAmount is a calculated field (derived from subtotal and tax %)
  // and normally not persisted in the UI, the backend requires this value to be included when saving
  // a record. This is used in v8, generating PDFs, reports, and other downstream processes.
  // For that reason, we copy the calculated taxAmount into the record before saving.
  const currencyMinimumFractionDigits =
    globalState.getState().userCompanySettings.localization
      .currencyMinimumFractionDigits;

  newRecord.taxAmount = getLocalizedValue(
    newRecord.totals.tax,
    currencyMinimumFractionDigits
  );
  delete newRecord.totals;

  // for each line
  const newLines = [];
  materialLines.forEach((line) => {
    let newLine = { ...line };

    newLine = normalizeJobWorkCenter(newLine);

    // normalize other reference fields; if no referenced record is selected,
    // set the field to null
    LINE_ITEM_FIELDS[objectType][TYPES.reference].forEach((field) => {
      if (
        line[field] &&
        typeof line[field].id === "string" &&
        line[field].id === ""
      ) {
        newLine[field] = null;
      }
    });

    // format the tax property, if a taxCode has been selected
    if (line.taxCode && line.taxCode !== "") {
      newLine.tax = {
        taxable: false, // if we're using tax codes, we're not using the taxable property
        taxCode: { id: line.taxCode.id },
      };
    }

    // convert any number or currency fields that are "" to zero
    const fieldsToCheck = LINE_ITEM_FIELDS[objectType][TYPES.number];
    fieldsToCheck.forEach((field) => {
      if (line[field] === "") {
        newLine[field] = 0;
      }
    });

    // convert item to remove unnecessary data
    if (line.item?.id) {
      newLine.item = { id: line.item.id, name: line.item.name };
    }

    // remove itemDetails from line; it's only used in this frontend
    delete newLine.itemDetails;

    // remove relatedRecords from line; it's only used in this frontend
    delete newLine.relatedRecords;

    newLines.push(newLine);
  });

  // remove depositPercent from the record; it's only used on the frontend
  delete newRecord.depositPercent;

  newRecord.customFields = convertNativeToCustom(record.customFields);

  // update the record with the new lines
  newRecord.lines = newLines;

  return newRecord;
}
